import { pathOr } from 'ramda'

import { access as ACCESS } from '@driftt/traffic-control'

import { createReducer } from 'utils/redux'

const defaultState = {
  embeds: {},
  hasMultiEmbed: ACCESS.hasGates('multi_language'),
  hasMultiLanguageDowngrade:
    !ACCESS.hasGates('multi_language') &&
    ACCESS.hasGates('is_multi_language_downgrade'),
  targetings: null,
}

const receiveMultiEmbedsHandler = ({ draft, action }) => {
  const embeds = action.payload
  const embedsById = embeds.reduce((embedsById, embed) => {
    embedsById[embed.id] = embed
    return embedsById
  }, {})

  draft.embeds = embedsById
}

const recieveUpdatedEmbedHandler = ({ draft, action }) => {
  draft.embeds[action.payload.id] = action.payload
}

const receiveHasMultiEmbedHandler = ({ draft, action }) => {
  draft.hasMultiEmbed = action.payload
}

const receiveHasMultiLanguageDowngradeHandler = ({ draft, action }) => {
  draft.hasMultiLanguageDowngrade = action.payload
}

const receiveBulkTargetingHandler = ({ draft, action }) => {
  const targetings = pathOr({}, ['payload'], action)
  draft.targetings = targetings
}

const receiveTargetingHandler = ({ draft, action }) => {
  const targeting = action.payload
  draft.targetings[targeting.embedId] = targeting
}

const actions = {
  RECEIVE_MULTI_EMBEDS: receiveMultiEmbedsHandler,
  RECEIVE_UPDATED_CHILD_EMBED: recieveUpdatedEmbedHandler,
  RECEIVE_MULTI_EMBED: receiveHasMultiEmbedHandler,
  RECEIVE_BULK_TARGETING: receiveBulkTargetingHandler,
  RECEIVE_TARGETING: receiveTargetingHandler,
  RECEIVE_HAS_MULTI_LANGUAGE_DOWNGRADE: receiveHasMultiLanguageDowngradeHandler,
}

const multiEmbedReducer = createReducer(defaultState, actions)

export default multiEmbedReducer
